import React, { useState } from "react";
import questions from "./Data";
import { Row, Col, Button, Container } from "react-bootstrap";
import "./SelfEsteem.css";
import { connect } from "react-redux";
import { myFirestore } from "../../../services/firebase";

let totalScore = 0;

function ScoreCard(props) {
  const [showScore, setShowScore] = useState(false);

  function handleResultClick() {
    if (showScore) {
      setShowScore(false);
    } else setShowScore(true);
  }

  return (
    <div className="result">
      <h3>Results</h3>
      <p>{props.content}</p>
      <br />
      <Button variant="secondary" onClick={handleResultClick}>
        Evaluation Criteria
      </Button>
      <br />
      {showScore && (
        <Container>
          <h5>Your Score : {totalScore}</h5>
          <br />
          <Row>
            <Col>Total Score</Col>
            <Col>Interpretation</Col>
          </Row>
          <Row>
            <Col>0 - 24</Col>
            <Col>Low Self-Esteem</Col>
          </Row>
          <Row>
            <Col>25 - 49</Col>
            <Col>Below Average Self-Esteem</Col>
          </Row>
          <Row>
            <Col>50 - 59</Col>
            <Col>Average Self-Esteem</Col>
          </Row>
          <Row>
            <Col>60 - 79</Col>
            <Col>Above Average Self-Esteem</Col>
          </Row>
          <Row>
            <Col>80 - 100</Col>
            <Col>High Self-Esteem</Col>
          </Row>
        </Container>
      )}
    </div>
  );
}

function SelectScoreCard() {
  if (totalScore >= 0 && totalScore <= 24) {
    return (
      <ScoreCard content="At this moment, according to the test you have taken, your scores indicate that you have a low self-esteem. You may experience difficulty with confidence and experience negative thoughts about yourself quite often. You might also find it difficult to speak up in your defense and might feel awkward when in the presence of strangers." />
    );
  } else if (totalScore >= 25 && totalScore <= 49) {
    return (
      <ScoreCard content="At this moment, according to the test you have taken, your scores indicate that you have a below average self-esteem. You may experience difficulty with confidence and experience negative thoughts about yourself quite often. You might also find it difficult to speak up in your defense and might feel awkward when in the presence of strangers." />
    );
  } else if (totalScore >= 50 && totalScore <= 59) {
    return (
      <ScoreCard content="At this moment, according to the test you have taken, your scores show that you have an Average self-esteem. " />
    );
  } else if (totalScore >= 60 && totalScore <= 79) {
    return (
      <ScoreCard content="At this moment, according to the test you have taken, your scores show that you have Above Average self-esteem. " />
    );
  } else if (totalScore >= 80 && totalScore <= 100) {
    return (
      <ScoreCard content="At this moment, according to the test you have taken, your scores show that you have High self-esteem." />
    );
  }
}

function SelfEsteemQuiz(props) {
  const [qno, setQno] = useState(0);
  let [ansArrayLike] = useState([]);
  let [ansArrayUnlike] = useState([]);
  const [show, setShow] = useState(true);

  let score = 0;

  function computeScore() {
    score =
      ansArrayLike[0] +
      ansArrayLike[3] +
      ansArrayLike[4] +
      ansArrayLike[7] +
      ansArrayLike[8] +
      ansArrayLike[13] +
      ansArrayLike[18] +
      ansArrayLike[19] +
      ansArrayUnlike[1] +
      ansArrayUnlike[2] +
      ansArrayUnlike[5] +
      ansArrayUnlike[6] +
      ansArrayUnlike[9] +
      ansArrayUnlike[10] +
      ansArrayUnlike[11] +
      ansArrayUnlike[12] +
      ansArrayUnlike[14] +
      ansArrayUnlike[15] +
      ansArrayUnlike[16] +
      ansArrayUnlike[17] +
      ansArrayUnlike[20] +
      ansArrayUnlike[22] +
      ansArrayUnlike[23] +
      ansArrayUnlike[24];

    totalScore = score * 4;

    if (props.auth.uid) {
      myFirestore
        .collection("testresults")
        .doc(props.auth.uid)
        .set(
          {
            SelfEsteem: {
              totalscore: totalScore,
            },
          },
          { merge: true }
        );
    } else {
      myFirestore
        .collection("anonresults")
        .doc()
        .set({
          SelfEsteem: {
            totalscore: totalScore,
          },
        });
    }
  }

  function handleLikeMe() {
    ansArrayLike.push(1);
    ansArrayUnlike.push(0);
    setQno((prev) => prev + 1);
    if (qno + 1 === 25) {
      setShow(false);
      computeScore();
    }
  }

  function handleUnlikeMe() {
    ansArrayLike.push(0);
    ansArrayUnlike.push(1);
    setQno((prev) => prev + 1);
    if (qno + 1 === 25) {
      setShow(false);
      computeScore();
    }
  }

  return (
    <div className="screen-bg">
      {show ? (
        <div className="quiz-bg">
          <p>Question {qno + 1} of 25</p>
          <h3>{questions[qno]}</h3>
          <div className="answers">
            <div onClick={handleLikeMe}>Like Me</div>
            <div onClick={handleUnlikeMe}>Unlike Me</div>
          </div>
        </div>
      ) : (
        <SelectScoreCard />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(SelfEsteemQuiz);
